<div *ngIf="loading"
     class="loading-overlay">
    <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
    <h3 class="mt-3 ml-1 text-secondary">Cargando...</h3>
</div>


<div class="row ">

    <div class="col-12">
        <div class="card border rounded animated fadeIn fast">
            <div class="card-body animated fadeIn fast">

                <!-- cabecera -->
                <div class="row mb-2">

                    <div class="col-3">
                        <div class="input-group border border-dark rounded">
                            <input class="form-control"
                                   type="text"
                                   id="buscaTodo"
                                   autofocus
                                   placeholder="Buscar cualquier dato..."
                                   [(ngModel)]="strBuscarTodo"
                                   (keyup)="buscarTodo($event)" />
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary"
                                        type="button"
                                        title="Limpiar búsqueda"
                                        (click)="limpiaBusca()">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>


                    <div class="col-3">
                        <div class=" input-group border border-dark rounded">
                            <div class="input-group-addon"><i class="fa-solid fa-warehouse"></i></div>
                            <select class="form-control "
                                    [(ngModel)]="almSeleccionado"
                                    (ngModelChange)="onAlmacenSelect($event)">
                                <option value=0>Todos los almacenes</option>
                                <option *ngFor="let alm of almacenesList"
                                        [value]=alm.id>
                                    {{alm.nombre}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="input-group border border-dark rounded">
                            <div class="input-group-addon"><i class="fa-solid fa-user"></i></div>
                            <select class="form-control"
                                    [disabled]="articuloAux.id !== undefined"
                                    [(ngModel)]="cliSeleccionado"
                                    (ngModelChange)="onClienteSelect($event)">
                                <option value=''>Todos los clientes</option>
                                <option *ngFor="let cli of clientesList"
                                        [value]=cli.id>
                                    {{cli.nombre}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col-3">
                        <form>

                            <div class="row float-right">
                                <div class="col-sm-7">
                                    <div class="form-group rounded">
                                        <select class="form-control"
                                                name="rowsLimitStr"
                                                [(ngModel)]="rowsLimitStr"
                                                (change)="rowsLimitChange()">
                                            <option [value]="10">10</option>
                                            <option [value]="50">50</option>
                                            <option [value]="100">100</option>
                                            <option [value]="999999">Todo</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-5">
                                    <div class="form-group float-right">
                                        <div class="btn-group">

                                            <button type="button"
                                                    (click)="getListaStock()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Recargar datos">
                                                <i class="fa-solid fa-sync"></i>
                                            </button>

                                            <button type="button"
                                                    (click)="exportToExcel()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Descargar Excel">
                                                <i class="fa-solid fa-download"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </form>
                    </div>

                </div>

                <span *ngIf="articuloAux.id">
                    <h2>Stock de Ean {{articuloAux.ean}}</h2>
                    <p class="text-muted"><strong>SKU: {{articuloAux.sku}}</strong> / {{articuloAux.descripcion}}</p>
                </span>

                <div class="rounded border">
                    <h5 class="text-info p-1">Stock ubicado</h5>


                    <!-- ngx-datatable -->
                    <ngx-datatable class='bootstrap'
                                   [columnMode]="ColumnMode.flex"
                                   [loadingIndicator]="loading"
                                   [headerHeight]="70"
                                   [footerHeight]="50"
                                   [rowHeight]="50"
                                   [limit]="rowsLimit"
                                   [rows]='rows'
                                   [messages]="messages"
                                   [footerHeight]="50"
                                   [summaryRow]="true"
                                   [summaryHeight]="55"
                                   [summaryPosition]="summaryPosition">


                        <!-- id -->
                        <ngx-datatable-column name="id"
                                              [flexGrow]="10">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'id')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer link">id</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div (dblclick)="dblclickCampo(value)"
                                     title="Doble click para busqueda global"
                                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>



                        <!-- id_articulo -->
                        <ngx-datatable-column name="id Art."
                                              prop='id_articulo'
                                              [flexGrow]="10">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'id_articulo')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer link">id Art.</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div (dblclick)="dblclickCampo(value)"
                                     title="{{row.clienteNombre}}">
                                    <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
                                </div>

                            </ng-template>
                        </ngx-datatable-column>



                        <!-- articulo_sku -->
                        <ngx-datatable-column name="articuloSku"
                                              [flexGrow]="20">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'articuloSku')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer link">SKU</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div (dblclick)="dblclickCampo(value)"
                                     title="{{row.clienteNombre}}">
                                    <span [ngClass]="{'defectuoso': row.articuloSwDefectuoso == Constantes.DEFECTUOSO}"
                                          [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
                                    <span *ngIf="row.articuloSwDefectuoso == Constantes.DEFECTUOSO">
                                        <i title="Defectuoso"
                                           class="text-warning ml-1 fa-solid fa-triangle-exclamation"></i>
                                    </span>
                                </div>

                            </ng-template>
                        </ngx-datatable-column>



                        <!-- articuloEan -->
                        <ngx-datatable-column name="articuloEan"
                                              [flexGrow]="20">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'articuloEan')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer link"><i class="fa fa-barcode"></i> Ean</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div (dblclick)="dblclickCampo(value)"
                                     title="{{row.clienteNombre}}"
                                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>





                        <!-- descripcion -->
                        <ngx-datatable-column name="descripcion"
                                              [flexGrow]="25">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'descripcion')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer  link">Descripción</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div (dblclick)="dblclickCampo(value)"
                                     title="{{row.descripcion}}"
                                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>





                        <!-- lote -->
                        <ngx-datatable-column name="lote"
                                              [flexGrow]="10">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'lote')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer link">Lote</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div (dblclick)="dblclickCampo(value)"
                                     title="Fecha caducidad: {{row.fechaCaducidad}}"
                                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>




                        <!-- ubiCodigo -->
                        <ngx-datatable-column name="ubiCodigo"
                                              pre="Ubicación"
                                              [flexGrow]="19">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'ubiCodigo')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer link">Ubicación</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div (dblclick)="dblclickCampo(value)"
                                     title={{funcLib.CodUbiDecript(value)}}
                                     class="monospace"
                                     [innerHTML]="funcLib.resaltarTexto(funcLib.formatUbicacion(value), textoDestacado | mask: '00.00.00.00.00.00')"></div>
                            </ng-template>
                        </ngx-datatable-column>




                        <!-- cantidad -->
                        <ngx-datatable-column name="cantidad"
                                              [flexGrow]="10"
                                              [cellClass]="'text-right'"
                                              [summaryFunc]="sumaCeldas">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'cantidad')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer link"
                                        title="Cantidad de artículos en esta ubicación">Stock</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                {{ value | number: '0.0-0':'es'}}
                                <small *ngIf="value && row.articulo.unidadesCaja > 0"
                                       title="{{row.articulo.unidadesCaja | number: '0.0-0':'es'}} Unidades por Caja"
                                       class="text-muted d-block"
                                       style="margin-top: -5px;">({{value / row.articulo.unidadesCaja | number: '0.0-0':'es'}} Cajas)</small>
                            </ng-template>
                        </ngx-datatable-column>



                        <!-- cantidadReservada -->
                        <ngx-datatable-column name="cantidadReservada"
                                              [flexGrow]="10"
                                              [cellClass]="'text-right'"
                                              [summaryFunc]="sumaCeldas">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'cantidadReservada')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer link"
                                        title="Cantidad reservada">Res.</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>{{ value | number: '0.0-0':'es' }}</ng-template>
                        </ngx-datatable-column>


                        <!-- cantidadDisponible -->
                        <ngx-datatable-column name="cantidadDisponible"
                                              [flexGrow]="15"
                                              [cellClass]="'text-right'"
                                              [summaryFunc]="sumaCeldas">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'cantidadDisponible')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer link"
                                        title="Cantidad bloqueada">Dispble.</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>{{ value | number: '0.0-0':'es' }}</ng-template>
                        </ngx-datatable-column>



                        <!-- bloqueado -->
                        <ngx-datatable-column name="bloqueado"
                                              [flexGrow]="10"
                                              [cellClass]="'text-right'"
                                              [summaryFunc]="sumaCeldas">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'bloqueado')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer link"
                                        title="Cantidad bloqueada">Bloq.</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>{{ value | number: '0.0-0':'es' }}</ng-template>
                        </ngx-datatable-column>



                        <!-- fechaEntrada -->
                        <ngx-datatable-column name="fechaEntrada"
                                              [flexGrow]="12">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'fechaEntrada')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer link">F.entrada</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div (dblclick)="dblclickCampo(value)"
                                     title="Doble click para busqueda global"
                                     style="font-family: 'Verdana', monospace; letter-spacing: 0.2px;"
                                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>




                        <!-- fechaCaducidad -->
                        <ngx-datatable-column name="fechaCaducidad"
                                              [flexGrow]="15">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'fechaCaducidad')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer  link">F.caducidad</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <span (dblclick)="dblclickCampo(value)"
                                      title="Doble click para busqueda global"
                                      style="font-family: 'Verdana', monospace; letter-spacing: 0.2px;"
                                      [innerHTML]="value | iconFechaCaducada"></span>
                            </ng-template>
                        </ngx-datatable-column>



                        <!-- Acciones -->
                        <ngx-datatable-column [flexGrow]="10"
                                              [sortable]="false"
                                              [draggable]="false"
                                              [resizeable]="false">

                            <ng-template let-row="row"
                                         let-value="value"
                                         ngx-datatable-cell-template>

                                <div ngbDropdown
                                     class="d-inline-block "
                                     container="body">
                                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                                            data-toggle="dropdown"
                                            type="button"
                                            style="border-width: 1px;">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-left">

                                        <a [routerLink]="row.cantidadDisponible >= 1 ? ['/panel/stock_mover_articulo', row.id] : null"
                                           class="link mr-2 dropdown-item"
                                           title="Mover referencia"
                                           [class.disabled]="row.cantidadDisponible < 1"
                                           [attr.aria-disabled]="row.cantidadDisponible < 1 ? true : null"
                                           (click)="row.cantidadDisponible < 1 ? $event.preventDefault() : null">
                                            <i class="fa-solid fa-box-open"></i> Mover referencia
                                        </a>

                                        <a [routerLink]="['/panel/stock_mover',row.id]"
                                           class="link mr-2 dropdown-item"
                                           title="Mover ubicación completa">
                                            <i class="fa-solid fa-dolly"></i> Mover ubicación
                                        </a>

                                        <a href="javascript: void(0);"
                                           (click)="abrirModalRegul(row)"
                                           class="link mr-2 dropdown-item"
                                           title="Regularizar mercancia">
                                            <i class="fa-solid fa-arrow-down-up-across-line"></i> Regularizar
                                        </a>

                                        <a href="javascript: void(0);"
                                           [class.disabled]="row.cantidadReservada == 0"
                                           [attr.aria-disabled]="row.cantidadReservada == 0 ? true : null"
                                           (click)="row.cantidadReservada == 0 ? $event.preventDefault() : deleteReserva(row)"
                                           class="link mr-2 dropdown-item"
                                           title="Eliminar reservas activas">
                                            <i class="fa-solid fa-xmark"></i> Eliminar reservas
                                        </a>

                                        <a href="javascript: void(0);"
                                           (click)="eanLabelsSrv.imprimirEanLabel(row.id_articulo)"
                                           class="link mr-2 dropdown-item"
                                           title="Generar etiquetas EAN">
                                            <i class="fa-solid fa-barcode"></i> Generar etiquetas EAN
                                        </a>

                                        <a [routerLink]="['/panel/articulo_edit',row.id_articulo]"
                                           class="link mr-2 dropdown-item"
                                           title="Editar artículo">
                                            <i class="fa-solid fa-pen-to-square"></i> Editar artículo
                                        </a>

                                        <hr style="margin: 0px;">

                                        <a (click)="deleteRow(row)"
                                           class="link mr-2 pointer dropdown-item text-danger"
                                           title="Borrar">
                                            <i class="fa-regular fa-trash-can fa"></i> Borrar
                                        </a>


                                    </div>
                                </div>

                            </ng-template>
                        </ngx-datatable-column>


                    </ngx-datatable>
                </div>


                <!-- Entradas aún NO ubicadas (en playas) -->
                <div class="mt-2"
                     *ngIf="!articuloAux.id">
                    <app-entradas-no-ubicadas [strBuscarTodo]="strBuscarTodo"
                                              [almSeleccionado]="almSeleccionado"
                                              [cliSeleccionado]="cliSeleccionado"> </app-entradas-no-ubicadas>
                </div>


                <!-- Stock en carros UIC -->
                <div class="mt-2"
                     *ngIf="!articuloAux.id">
                    <app-preparaciones-lista [strBuscarTodo]="strBuscarTodo"
                                             [almSeleccionado]="almSeleccionado"
                                             [cliSeleccionado]="cliSeleccionado"></app-preparaciones-lista>
                </div>


            </div>
        </div>
    </div>

</div>

<!-- <app-modal-regularizar *ngIf="stockAeditar" [stock]="stockAeditar"></app-modal-regularizar> -->
<app-modal-regularizar></app-modal-regularizar>